import api from './api';

export interface FeatureRequest {
  id: number;
  userId?: number | null;
  title: string;
  description: string;
  category: 'feature' | 'improvement' | 'bug_fix' | 'ui_ux' | 'integration' | 'other';
  status: 'under_review' | 'planned' | 'in_progress' | 'completed' | 'rejected' | 'duplicate';
  priority?: 'low' | 'medium' | 'high' | 'urgent' | null;
  voteCount: number;
  adminResponse?: string | null;
  isPublic?: boolean;
  adminUserId?: number | null;
  respondedAt?: string | null;
  createdAt: string;
  updatedAt: string;
  user?: {
    id: number;
    username: string;
    firstName: string;
    lastName: string;
  } | null;
  admin?: {
    id: number;
    username: string;
    firstName: string;
    lastName: string;
  } | null;
  votes?: Array<{
    id: number;
    userId?: number | null;
  }>;
  userVoted?: boolean;
}

export interface FeatureRequestListResponse {
  success: boolean;
  data: FeatureRequest[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const featureRequestService = {
  async create(
    data: {
      title: string;
      description: string;
      category: 'feature' | 'improvement' | 'bug_fix' | 'ui_ux' | 'integration' | 'other';
    },
    signal?: AbortSignal
  ): Promise<{ success: boolean; data: FeatureRequest; message: string }> {
    const response = await api.post('/feature-requests', data, signal ? { signal } : undefined);
    return response.data;
  },

  async list(
    params?: {
      page?: number;
      limit?: number;
      category?: string;
      status?: string;
      priority?: string;
      sort?: 'recent' | 'popular';
      q?: string;
      unanswered?: boolean;
    },
    signal?: AbortSignal
  ): Promise<FeatureRequestListResponse> {
    const response = await api.get('/feature-requests', { params, signal });
    return response.data;
  },

  async getById(id: number): Promise<{ success: boolean; data: FeatureRequest }> {
    const response = await api.get(`/feature-requests/${id}`);
    return response.data;
  },

  async update(id: number, data: {
    status?: 'under_review' | 'planned' | 'in_progress' | 'completed' | 'rejected' | 'duplicate';
    priority?: 'low' | 'medium' | 'high' | 'urgent' | null;
    adminResponse?: string | null;
    isPublic?: boolean;
  }): Promise<{ success: boolean; data: FeatureRequest }> {
    const response = await api.put(`/feature-requests/${id}`, data);
    return response.data;
  },

  async vote(id: number): Promise<{ success: boolean; data: FeatureRequest; message: string }> {
    const response = await api.post(`/feature-requests/${id}/vote`);
    return response.data;
  },

  async unvote(id: number): Promise<{ success: boolean; data: FeatureRequest; message: string }> {
    const response = await api.delete(`/feature-requests/${id}/vote`);
    return response.data;
  },

  /** 管理者のみ（API 側で検証） */
  async deleteById(id: number): Promise<{ success: boolean; message?: string }> {
    const response = await api.delete(`/feature-requests/${id}`);
    return response.data;
  },
};

